import { useEffect, useMemo } from 'react';
import debounce from 'lodash/debounce';

import { SearchIcon } from '@svgs';

export const FilterField = ({
  disabled = false,
  searchTerm,
  setSearchTerm,
}) => {
  const handleFilterChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // https://medium.com/nerd-for-tech/debounce-your-search-react-input-optimization-fd270a8042b
  const debouncedResults = useMemo(() => {
    return debounce(handleFilterChange, 300);
  }, []);
  useEffect(() => {
    return () => {
      debouncedResults.cancel();
    };
  });

  return (
    <form
      role="search"
      className="sb-manage-options-search"
      onSubmit={(e) => e.preventDefault()}
    >
      <input
        type="search"
        name="query"
        placeholder="Filter"
        aria-label="Enter search term"
        autoComplete="off"
        defaultValue={searchTerm}
        onChange={debouncedResults}
        spellCheck={false}
        disabled={disabled}
      />
      <SearchIcon />
    </form>
  );
};
